import { LOCALE_FR, LOCALE_NL, type Locale, SUPPORTED_LOCALES } from '@/i18n/main'
import type { Claim } from '@/types/claim'
import { ActiveClaimStatuses, ClosedClaimStatuses } from '@/types/claim'
import type { PendingClaim } from '@/types/me'
import { capitalizeFirstLetter } from '@/utils/utils'
import { useI18n } from 'vue-i18n'

export const MINIMUM_YEAR_FOR_STROOBANTS_CLAIMS = 2024
export const INVALID_STROOBANTS_CLAIMS_INCIDENT_YEAR = 1970

export const filterStroobantsClaims = (claims: Claim[]) => {
  return sortedClaimsByDate(claims).filter((claim) => {
    const year = Number(claim.reportingDate.split('/')[2])
    const incidentYear = Number((claim.incidentDate || claim.reportingDate).split('/')[2])
    return (
      incidentYear !== INVALID_STROOBANTS_CLAIMS_INCIDENT_YEAR &&
      (ActiveClaimStatuses.includes(claim.status) || year >= MINIMUM_YEAR_FOR_STROOBANTS_CLAIMS)
    )
  })
}

const parseDate = (str: string) => {
  const [day, month, year] = str.split('/').map(Number)
  return new Date(year, month - 1, day)
}

export const filterActiveClaims = (claims: Claim[]) => {
  const activeClaims = claims.filter((claim) => ActiveClaimStatuses.includes(claim.status))
  return sortedClaimsByDate(activeClaims)
}

export const filterClosedClaims = (claims: Claim[]) => {
  const closedClaims = claims.filter((claim) => ClosedClaimStatuses.includes(claim.status))
  return sortedClaimsByDate(closedClaims)
}

export const sortedClaimsByDate = (claims: Claim[]) => {
  return claims.sort(
    (a, b) =>
      parseDate(b.incidentDate || b.reportingDate).getTime() - parseDate(a.incidentDate || a.reportingDate).getTime()
  )
}

export const claimLabel = (claim: Claim | PendingClaim) => {
  const { locale, t } = useI18n()
  if (claim.productLine && SUPPORTED_LOCALES.includes(locale.value as Locale)) {
    let productLine = ''

    if (locale.value === LOCALE_FR) productLine = claim.productLine.fr
    else if (locale.value === LOCALE_NL) productLine = claim.productLine.nl
    else productLine = claim.productLine.en

    return capitalizeFirstLetter(t(`terms.claim.type`, { productLine: productLine }))
  } else {
    return t(`terms.contract.product_types.${claim.productType}`)
  }
}
